import React from 'react';
import StatusPage from './StatusPage.jsx';

/** 403 — authenticated but not allowed. */
export default function Forbidden() {
  return (
    <StatusPage
      code="403"
      title="Access denied"
      message="You do not have permission to access this page. Contact your administrator if you believe this is a mistake."
      icon="fa-ban"
    />
  );
}
